import { NavigationOutcome } from "@/contexts/session/ui/use-reference-navigation";
import { LogLevel, type useSeqLog } from "@/hooks/telemetry";
import type { CreferenceEntityType } from "./CreferenceEntity";
import type { InternalReferenceAction } from "./creferenceInteractionTypes";

type CreferenceSeqLog = ReturnType<typeof useSeqLog>;

interface CreferenceClickLogInput {
  canClick: boolean;
  entityType: CreferenceEntityType;
  normalizedEntityId: string;
  onClick?: () => void;
  seqLog: CreferenceSeqLog;
}

interface CreferenceExternalClickInput {
  normalizedEntityId: string;
  onClick?: () => void;
  seqLog: CreferenceSeqLog;
}

interface CreferenceInternalClickInput {
  action: InternalReferenceAction | undefined;
  showAlreadyFocusedHint: () => void;
}

export function logCreferenceClickEntry({
  canClick,
  entityType,
  normalizedEntityId,
  onClick,
  seqLog,
}: CreferenceClickLogInput): void {
  seqLog("01 Creference.handleClick entry", {
    entityType,
    entityId: normalizedEntityId,
    canClick,
    hasOnClick: Boolean(onClick),
  }, LogLevel.Info);
}

export function logCreferenceClickBlocked({
  normalizedEntityId,
  seqLog,
}: Pick<CreferenceClickLogInput, "normalizedEntityId" | "seqLog">): void {
  seqLog("01a Creference.handleClick: canClick=false, returning", {
    entityId: normalizedEntityId,
  }, LogLevel.Info);
}

export function runCreferenceExternalClick({
  normalizedEntityId,
  onClick,
  seqLog,
}: CreferenceExternalClickInput): boolean {
  if (!onClick) {
    return false;
  }

  seqLog("01b Creference.handleClick: onClick prop, returning", {
    entityId: normalizedEntityId,
  }, LogLevel.Info);
  onClick();
  return true;
}

export function runCreferenceInternalClick({
  action,
  showAlreadyFocusedHint,
}: CreferenceInternalClickInput): void {
  if (action?.() === NavigationOutcome.Noop) {
    showAlreadyFocusedHint();
  }
}
